var ActivityShell;
(function (ActivityShell) {
    ActivityShell["Wizard"] = "WIZARD";
    ActivityShell["Chatbot"] = "CHATBOT";
    ActivityShell["Witch"] = "WITCH";
})(ActivityShell || (ActivityShell = {}));
export default ActivityShell;
//# sourceMappingURL=ActivityShell.js.map